import api from './api';

export const reportService = {
    getStudentOverview: async (studentId) => {
        return await api.get(`/reports/student/${studentId}/overview`);
    },

    getStudentProgress: async (studentId) => {
        return await api.get(`/reports/student/${studentId}/progress`);
    },

    getStudentActivity: async (studentId) => {
        return await api.get(`/reports/student/${studentId}/activity`);
    },

    getStudentBadges: async (studentId) => {
        return await api.get(`/reports/student/${studentId}/badges`);
    },

    generateReport: async (studentId, reportPeriod, periodStart, periodEnd) => {
        return await api.post('/reports/generate', {
            student_id: studentId,
            report_period: reportPeriod,
            period_start: periodStart,
            period_end: periodEnd
        });
    }
};